import {Vue as _Vue} from 'vue/types/vue'
import {VueModule} from 'vue-modules'
import {bind, RepositoryInterface} from "@/service/utils";
import VueRouter from "vue-router";
import {Store} from "vuex";
import Vue from "vue";


export class ServiceModule implements VueModule {
  readonly name = 'store'
  service?: any;

  constructor(private modules: Array<string>) {}

  install(Vue: typeof _Vue) {
    this.service = this.modules.reduce((prev,module: string) => {
        try {
          const Module = require(`@/modules/${module}/service`)
          return {
            ...prev,
            ...Module[`${module}Service`]
          }
        } catch (err) {
          return prev
        }
      }, {}
    );
  }
}
